<template>
  <div class="navbar">
    <hamburger
      id="hamburger-container"
      :is-active="sidebar.opened"
      class="hamburger-container"
      @toggleClick="toggleSideBar"
    />

    <ProjectSelector></ProjectSelector>

    <div class="right-menu">
      <el-dropdown >
        <div class="text-button" style="    line-height: 50px;">
          <span style="cursor: default;color:#0980fc">Tako下载</span>
          <i class="button-icon iconfont icon-arrow_downbold" style="cursor: default;color:#0980fc"></i>
        </div>
        <template #dropdown>
          <el-dropdown-menu>
            <el-dropdown-item
            ><router-link to="/d/takoios">
              <span style="color: #807f7d">iOS下载</span></router-link
            >
            </el-dropdown-item>
            <el-dropdown-item
            ><router-link to="/d/takoad">
              <span style="color: #807f7d">Android下载</span></router-link
            ></el-dropdown-item
            >
          </el-dropdown-menu>
        </template>
      </el-dropdown>
      <router-link to="/home/doc" target="_blank" class="right-menu-item"
        ><div class="text-button">文档</div></router-link
      >
      <el-dropdown trigger="click">
        <div class="avatar-container right-menu-item hover-effect">
          <span class="avatar-wrapper">
            <i class="iconfont icon-avatar"></i>
            <i class="iconfont icon-caret-bottom" style="font-size: 12px"></i>
          </span>
        </div>
        <template #dropdown>
          <el-dropdown-menu>
            <el-dropdown-item divided>
              <span style="display: block" @click="handleLogout">退出登录</span>
            </el-dropdown-item>
          </el-dropdown-menu>
        </template>
      </el-dropdown>
    </div>
  </div>
</template>

<script setup>
import { storeToRefs } from "pinia";
import Hamburger from "@/Components/Hamburger.vue";
import ProjectSelector from "@/Components/ProjectSelector.vue";
import { removeToken } from "@/Utils/Auth";
import { useAppStore } from "@/Store/AppStore";
import { useTechStore } from "@/Store/TechStore";
import { useProjectStore } from "@/Store/ProjectStore";
import * as Settings from "@/settings";

const appStore = useAppStore();
const techStore = useTechStore();
const projectStore = useProjectStore();

const { sidebar } = storeToRefs(appStore);
function toggleSideBar() {
  appStore.toggleSideBar();
}

async function handleLogout() {
  // 通过清空cookie退出登录
  removeToken();
  // store 状态清空
  techStore.$reset();
  projectStore.$reset();

  // 向服务端请求
  const logoutUrl =
    Settings.ssoServerUrl +
    "/sso/logout?service=" +
    encodeURIComponent(window.location.href);
  window.location.href = logoutUrl;
}
</script>

<style lang="scss" scoped>
.navbar {
  height: 50px;
  position: relative;
  background: #fff;
  box-shadow: 0 1px 4px rgba(0, 21, 41, 0.08);
  border-bottom: 1px solid #efefef;

  .hamburger-container {
    line-height: 46px;
    height: 100%;
    float: left;
    cursor: pointer;
    transition: background 0.3s;
    -webkit-tap-highlight-color: transparent;

    &:hover {
      background: rgba(0, 0, 0, 0.025);
    }
  }
  .right-menu {
    float: right;
    height: 100%;
    line-height: 50px;
    position: relative;
    margin-right: 10px;
    display: flex;
    align-items: stretch;
    &:focus {
      outline: none;
    }

    .right-menu-item {
      display: inline-block;
      margin: 0 7px;
      height: 100%;
      color: #5a5e66;
      vertical-align: text-bottom;
      display: flex;
      align-items: center;

      &.hover-effect {
        cursor: pointer;
        transition: background 0.3s;
      }

      .text-button {
        font-size: 16px;
        padding: 0 8px;
        color: #0980fc;
        &:hover {
          color: #79bbff;
        }
      }
    }
  }
}

.avatar-wrapper {
  font-size: 2em;
  color: #333333;
  cursor: pointer;
  &:hover {
    color: darkgoldenrod;
  }
}
</style>
